import { COUNTRY_CODES } from "../constants/AppConstants";
import { isEmpty } from "../utils/Util";

export function formatPhoneNumber(inputNumber: any, countryCode: string) {
  if (!inputNumber) return "";

  const cleaned = String(inputNumber).replace(/\D/g, "");

  const isUS = COUNTRY_CODES.US.includes(countryCode);
  const isCAN = COUNTRY_CODES.CA.includes(countryCode);

  // US & Canada both use NANP (10-digit format)
  if ((isUS || isCAN) && cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  }

  return cleaned;
}

export function getDealerAddressInfo(row: any) {
  let city = row.city;
  let stateOrProvince = row.stateOrProvince;

  if (isEmpty(city) && isEmpty(stateOrProvince)) return "";
  if (isEmpty(city) && !isEmpty(stateOrProvince)) return stateOrProvince;
  if (!isEmpty(city) && isEmpty(stateOrProvince)) return city;

  return city + ", " + stateOrProvince;
}

export function getDealerContactInfo(row: any) {
  let phone = row.phone;
  let email = row.email;

  const formattedPhone = !isEmpty(phone)
    ? formatPhoneNumber(phone, row.countryCode.toUpperCase() ?? "")
    : "";

  if (isEmpty(phone) && isEmpty(email)) return "";
  if (isEmpty(phone) && !isEmpty(email)) return email;
  if (!isEmpty(phone) && isEmpty(email)) return formattedPhone;

  return email + ", " + formattedPhone;
}

export function getPricingModelDetail(row: any, key: any) {
  if (isEmpty(row)) return "";

  const fixedAmount = row.markupFee;
  const variablePercentage = row.markupRate;
  const monthlyFee = row.monthlyFee;
  const description = row.description;

  if (key === "fee") {
    if (isEmpty(fixedAmount)) return "";
    return fixedAmount;
  } else if (key === "monthlyFee") {
    if (isEmpty(monthlyFee)) return "";
    return monthlyFee;
  } else if (key === "percentage") {
    if (isEmpty(variablePercentage)) return "";
    return variablePercentage;
  } else if (key === "name") {
    return (
      description +
      " (Markup: " +
      variablePercentage +
      "%, Fixed: " +
      fixedAmount +
      "$, Monthly: " +
      monthlyFee +
      "$)"
    );
  }
}
